const subheadingData = {
  1: [
    {
      title: 'About Me',
      content: (
        <>
          <p>
            Hi there! I'm a Full-Stack Web Developer with over three years of
            experience, specializing in building robust and scalable platforms.
            My time at Haply Robotics, along with my freelance projects, has
            given me hands-on expertise with technologies like React.js,
            Node.js, and AWS. I've also developed demo applications, including
            clones of Tinder, Facebook, and Airbnb, which have sharpened my
            problem-solving skills and deepened my understanding of user
            experience. With a strong commitment to quality and a diverse
            background, I consistently deliver impactful solutions.
          </p>
        </>
      ),
    },
  ],
  2: [
    {
      title: 'Concordia University',
      content: (
        <>
          <p>
            At Concordia University, I completed their Full-Stack Web Developer
            diploma program, where I gained hands-on experience in both frontend
            and backend development. The program covered key technologies like
            JavaScript, React.js, Node.js, and database management with MongoDB
            and SQL. I worked on real-world projects, learning best practices in
            coding, version control with Git, testing with Jest, and agile
            development. The curriculum emphasized building scalable web
            applications, API integration, and responsive design.
          </p>
        </>
      ),
    },
    {
      title: 'Vancouver Community College',
      content: (
        <>
          <p>
            At Vancouver Community College, I completed a diploma in Jazz
            Arrangement, where I developed a deep understanding of composition,
            harmony, and improvisation. Studying jazz taught me how to think
            creatively within structured frameworks, solve complex musical
            problems, and collaborate effectively with other musicians. These
            skills have directly influenced my approach to web
            development—writing clean, efficient code feels similar to composing
            music, where each element needs to work harmoniously within the
            whole.
          </p>
        </>
      ),
    },
  ],
  3: [
    {
      title: '2025 Fullstack Developer - Freelance',
      content: (
        <>
          <p>Freelance Developer working on various projects.</p>
        </>
      ),
    },
    {
      title: '2022 Fullstack Developer - Haply Robotics',
      content: (
        <>
          <p>
            I worked at Haply Robotics Inc from 2022 - 2024 as a Fullstack
            Developer. At Haply I contributed to building their web platform for
            haptic technology. My role involved developing and maintaining React
            and Next.js applications, integrating APIs, and optimizing frontend
            performance to ensure a smooth user experience.
          </p>
        </>
      ),
    },
    {
      title: '2021 Fullstack Developer',
      content: (
        <>
          <p>
            During this time I tackled various personal projects, including
            building clones of well-known apps like Tinder, Facebook, and
            Airbnb, which have sharpened my problem-solving abilities and
            deepened my understanding of user experience.
          </p>
        </>
      ),
    },
  ],
}

export default subheadingData
